export default __webpack_public_path__ + "static/media/promo.fb955bbb.svg";